<template>

    <div>
        <div id="footer">
            <div class="footerText">

                <div class="friendshiLinks" v-if="friendLinksDataList.length > 0">
                    <span class="friendshipText">友情链接</span>
                    <div class="friendshiLinksList">
                        <span v-for="(item, idx) in friendLinksDataList" :key="idx">
                            <a :href="item.url" :target="item.target">{{item.name}}</a>
                            <a v-if='idx != friendLinksDataList.length-1'>|</a>
                        </span>
                    </div>
                </div>
                <div class="footerBottom">
                    <div class="footerBottomRight">
                        <!-- <img src="../../assets/images/wechatCode.png"> -->
                        <div>
                            <img :src="site.site_wechat_qrcode" alt='官方微信公众号'>
                            <span>官方微信公众号</span>
                        </div>
                        <div>
                            <img :src="site.site_staff_qrcode">
                            <span>客服微信</span>
                        </div>

                    </div>

                    <div class="footerBottomLeft">
                        <p>主办：{{site.site_owner}}</p>
                        <p>地址：{{site.site_address}}</p>
                        <p>邮编：{{site.site_code}}</p>
             
                        <p>Copyright © {{year}} 版权所有 <a href='http://beian.miit.gov.cn' target='_blank'>{{site.site_icp}}</a></p>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>

import { mapState } from "vuex";

export default {
    name: '',
    components: {
    },
    computed: {
        ...mapState({
            site: state => state.user.site
        }),
    },
    data () {
        return {
            friendLinksDataList: [],
            year: ''
        }
    },

    created () {
        this.friendLinks(); //首页友情链接

        this.getYear();

        /**
         * 公共信息
         */
        if (!sessionStorage.getItem('site')) {
            this.getSite();
        } else {
            this.$store.commit('updateSite', JSON.parse(sessionStorage.getItem('site')));
        }
        // if (!this.getCookie('site')) {
        //     this.getSite();
        // } else {
        //     this.$store.commit('updateSite', JSON.parse(this.getCookie('site')));
        // }
    },
    methods: {
        getYear () {
            let date = new Date();
            this.year = date.getFullYear();
        },
        // 首页友情链接
        friendLinks () {
            let friendLinkseParams = {}

            this.$store.dispatch('friendLinks', friendLinkseParams)
                .then((res) => {
                    if (res.code == 200) {
                        this.friendLinksDataList = res.data
                    }
                }).catch(error => {
                    console.log('catch====', error)
                })
        },
        /**
         * 获取网站基本信息
         */
        getSite () {

            this.$store.dispatch('getSite', {}).then(res => {
                // this.setCookie('site', JSON.stringify(res.data), 'h2');
                sessionStorage.setItem('site', JSON.stringify(res.data))
                this.$store.commit('updateSite', res.data);
            })
        },

        setCookie (name, value, time) {
            var strsec = this.getsec(time);
            var exp = new Date();
            exp.setTime(exp.getTime() + strsec * 1);
            document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString();
        },
        //读取cookies
        getCookie (name) {
            var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
            if (arr = document.cookie.match(reg)) return unescape(arr[2]);
            else return null;
        },
        getsec (str) {
            var str1 = str.substring(1, str.length) * 1;
            var str2 = str.substring(0, 1);
            if (str2 == "s") {
                return str1 * 1000;
            } else if (str2 == "h") {
                return str1 * 60 * 60 * 1000;
            } else if (str2 == "d") {
                return str1 * 24 * 60 * 60 * 1000;
            }
        },
        checkCookie (c_name) {
            username = getCookie(c_name);
            if (username != null && username != "") { return true; }
            else { return false; }
        },
        clearCookie (name) {
            setCookie(name, "", -1);
        }
    }
}
</script>

<style scoped>
#footer {
    background-image: -webkit-linear-gradient(top, #56a6f9, #0173ff);
    background-image: -o-linear-gradient(top, #56a6f9, #0173ff);
    background-image: -ms-linear-gradient(top, #56a6f9, #0173ff);
    background-image: linear-gradient(top, #56a6f9, #0173ff);
    padding: 25px 0;
}

.footerText {
    /* text-align: center; */
    color: #fff;
    font-size: 12px;
    line-height: 22px;
    width: 1200px;
    margin: 0 auto;
}

.lastLine {
    margin-top: 10px;
}

.lastLine a {
    color: #fff;
}

.friendshiLinks {
    font-size: 14px;
    padding-left: 100px;
    position: relative;
    border-bottom: 1px solid rgba(255, 255, 255, 0.5);
}

.friendshiLinks a {
    color: #fff;
    display: inline-block;
    margin: 10px 5px 10px;
}

.friendshipText {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 2px;
}

.footerBottom {
    margin-top: 20px;
    overflow: hidden;
    padding: 0 98px;
    text-align: center;
}
.footerBottom > div {
    display: inline-block;
    vertical-align: middle;
}

.footerBottomLeft {
    text-align: left;
    padding-left: 20px;
}
.footerBottomLeft > p {
    font-size: 14px;
    color: #fff;
    line-height: 28px;
}

.footerBottomLeft > p > a {
    color: #fff;
}

.footerBottomRight img {
    display: block;
    width: 134px;
    height: 134px;
}
.footerBottomRight > div{
    display: inline-block;
    margin :0 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/common/commonFooter.vue